import React from 'react';
import { Col } from '../../components/RowCol';
import { Question } from './Game';
import styles from '../../style';
import dailyDoubleImage from '../../images/daily-double.jpeg';
import finalJeopardyImage from '../../images/final-jeopardy.jpg';
import LocalFileStorage from '../../LocalFileStorage';
import LocalImage from '../../components/LocalImage';

type Props = {
	question: Question;
	dailyDoubleWager: number | null;
	finalJeopardy: boolean;
	finalJeopardyWagers: [number, number] | null;
	localFileStorage: LocalFileStorage;
};

const withLineBreaks = (text: string): React.ReactNode =>
	text.split('\n').map((line, lineIndex) => (
		<div key={lineIndex}>
			{line}
		</div>
	));

const BigQuestion: React.FC<Props> = ({
	question,
	dailyDoubleWager,
	finalJeopardy,
	finalJeopardyWagers,
	localFileStorage,
}) => {
	if (question.dailyDouble && dailyDoubleWager === null) {
		return (
			<Col fill center style={{
				backgroundImage: `url(${dailyDoubleImage})`,
				backgroundPosition: 'center center',
				backgroundSize: 'contain',
				backgroundRepeat: 'no-repeat',
			}} />
		);
	}

	if (finalJeopardy && finalJeopardyWagers === null) {
		return (
			<Col fill center style={{
				backgroundImage: `url(${finalJeopardyImage})`,
				backgroundPosition: 'center center',
				backgroundSize: 'contain',
				backgroundRepeat: 'no-repeat',
			}} />
		);
	}

	if ('image' in question) {
		return (
			<Col fill style={{
				outline: '1px solid white',
				alignItems: 'center',
				justifyContent: 'space-around',
				paddingTop: '50px',
				paddingBottom: '50px',
			}}>
				<div style={{
					paddingLeft: '50px',
					paddingRight: '50px',
					textAlign: 'center',
					fontFamily: styles.questionFont,
					fontSize: styles.questionFontSize,
					textTransform: 'uppercase',
					textShadow: styles.shadow4,
					color: styles.questionColor,
				}}>
					{withLineBreaks(question.text)}
				</div>

				<div style={{
					width: '800px',
					height: '400px',
				}}>
					<LocalImage
						localFileStorage={localFileStorage}
						dbKey={question.image}
						style={{
							objectFit: 'contain',
							width: '100%',
							height: '100%',
						}}
					/>
				</div>
			</Col>
		);
	}

	if ('text' in question) {
		return (
			<Col fill center style={{
				backgroundColor: '#2f0dd3',
			}}>
				<div style={{
					padding: '50px',
					textAlign: 'center',
					fontFamily: styles.questionFont,
					fontSize: styles.questionFontSize,
					textTransform: 'uppercase',
					textShadow: styles.shadow4,
					color: styles.questionColor,
				}}>
					{withLineBreaks(question.text)}
				</div>
			</Col>
		);
	}

	// if ('lines' in question) {
	// 	return (
	// 		<Col fill center style={{
	// 			backgroundColor: '#2f0dd3',
	// 		}}>
	// 			<div style={{
	// 				padding: '50px',
	// 				textAlign: 'center',
	// 				fontFamily: styles.questionFont,
	// 				fontSize: styles.questionFontSizeLines, // different
	// 				textTransform: 'uppercase',
	// 				textShadow: styles.shadow4,
	// 				color: styles.questionColor,
	// 			}}>
	// 				{question.lines.map((line, lineIndex) => (
	// 					<React.Fragment
	// 						key={lineIndex}
	// 					>
	// 						<div>
	// 							{line}
	// 						</div>
	// 						{lineIndex < question.lines.length - 1 && (
	// 							<Spacer vertical={30} />
	// 						)}
	// 					</React.Fragment>
	// 				))}
	// 			</div>
	// 		</Col>
	// 	);
	// }
	return null;
};

export default BigQuestion;
